// extracted by mini-css-extract-plugin
export default {"container":"Details_container__2yb35","copyUssd":"Details_copyUssd__1oH14","code":"Details_code__Fyihp","inputNote":"Details_inputNote__OMVlf"};